<template>
	<section v-if="!error">
		<h1>Ihre Beschwerde wurde bestätigt</h1>
		<p>
			Vielen Dank für Ihre Beschwerde. Wir haben den Fall zur Bearbeitung in unserem System aufgenommen. In einem ersten Schritt überprüfen wir unsere
			Zuständigkeit und melden uns bei Rückfragen.
		</p>
		<p>
			Erst nach Abschluss des Bearbeitungs- bzw. Entscheidungsverfahrens wird Ihre Beschwerde veröffentlicht und
			<RouterLink :to="'/beschwerden'" :title="'Alle Beschwerden'" class="link"> hier </RouterLink> abrufbar sein.
		</p>
	</section>
	<section v-else>
		<h1>Es gab ein Problem beim Bestätigen Ihrer Beschwerde</h1>
		<p>{{ errorMsg }}</p>
	</section>
</template>

<script lang="ts">
import TheButton from '@/components/TheButton.vue';
import { confirmComplaint } from '@/requests/complaints';
import { startLoading, stopLoading } from '@/utils/loading/loadingHandler';
import { texts } from '@/utils/texts';
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'BeschwerdeConfirm',
	data() {
		return {
			waiting: false,
			error: false,
			errorMsg: '',
		};
	},
	components: {
		TheButton,
	},
	props: {
		id: {
			type: String,
			required: true,
		},
	},
	methods: {
		async confirmComplaint() {
			this.waiting = true;
			const loading = startLoading('#complaint');

			const result = await confirmComplaint({
				complaintId: this.id,
				token: this.token,
			});

			if (!result.success) {
				this.error = true;
				this.errorMsg = texts.complaints.saveFailed;
			}

			this.waiting = false;
			stopLoading(loading);
		},
	},
	computed: {
		token() {
			return this.$route.query.token as string;
		},
		texts() {
			return texts;
		},
	},
	mounted() {
		if (this.id && this.token) {
			this.confirmComplaint();
		}
	},
});
</script>
